import React, { useEffect, useState } from "react";
import icon5 from "../../Assets/Image/admin/5.png";
import { useNavigate } from "react-router-dom";
import { Images } from "lucide-react";
import { getDashboardCount } from "../../Services/ApiServices";
import toast from "react-hot-toast";
import Cookies from "js-cookie";
import { Bars } from "react-loader-spinner";
import nodata from "../../Assets/Image/admin/nodata.png";

function Dashboard() {
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [newCount, setNewCount] = useState({});

  const handleDashbord = () => {
    setLoader(true);
    getDashboardCount()
      .then((res) => {
        setNewCount(res.data.data);
        setLoader(false);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err.response.data.message);
        }
        setLoader(false);
      });
  };

  useEffect(() => {
    handleDashbord();
  }, []);

  return (
    <>
      <div className="grid grid-cols-12 gap-4 fontNew md:m-4 m-1">
        <div className="col-span-12">
          <div>
            <div className="grid grid-cols-12 gap-4">
              {loader ? (
                <div className="flex justify-center items-center col-span-12 h-[70vh]">
                  <Bars
                    height="35"
                    width="35"
                    color="#e29c29"
                    ariaLabel="bars-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={true}
                  />
                </div>
              ) : (
                <>
                  {!newCount ? (
                    <div className="col-span-12 h-[50vh] justify-center flex items-center">
                      <img src={nodata} className="w-28" alt="No data" />
                    </div>
                  ) : (
                    <>
                      <div
                        onClick={() => {
                          navigate("/users");
                        }}
                        className="2xl:col-span-3 xl:col-span-4 lg:col-span-6 sm:col-span-6 col-span-12 bg-white p-5 rounded-2xl fontNew hover:drop-shadow-lg duration-300 cursor-pointer"
                      >
                        <img src={icon5} className="w-12 py-2" alt="" />
                        <p className="text-4xl pb-3 font-semibold my-2">
                          {newCount.userCount || "0"}
                        </p>
                        <p className="text-base">Total Users</p>
                      </div>
                      <div
                        onClick={() => {
                          navigate("/brand");
                        }}
                        className="2xl:col-span-3 xl:col-span-4 lg:col-span-6 sm:col-span-6 col-span-12 bg-white p-5 rounded-2xl fontNew hover:drop-shadow-lg duration-300 cursor-pointer"
                      >
                        <div className="bg-[#5B93FF] w-12 h-12 rounded-full flex justify-center items-center my-2">
                          <Images color="white" size={24} />
                        </div>
                        <p className="text-4xl pb-3 font-semibold py-2">
                          {newCount.categorycount || "0"}
                        </p>
                        <p className="text-base">Total Category</p>
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Dashboard;
